module.exports = __webpack_public_path__ + "static/media/ellipse-left.8686d511.png";